<template>
    <div>
        <label v-if="labelCaption" class="label-caption">{{ labelCaption }}</label>
        <div class="toggle-wrapper">
            <button
                :class="['btn-toggle left', { active: modelValue === true }]"
                :style="{ width: btnWidth }"
                @click="updateValue(true)">
                {{ labelTrue }}
            </button>

            <button
                :class="['btn-toggle right', { active: modelValue === false }]"
                :style="{ width: btnWidth }"
                @click="updateValue(false)">
                {{ labelFalse }}
            </button>
        </div>
    </div>
</template>

<script setup>
const { modelValue, labelTrue, labelFalse, labelCaption, btnWidth } = defineProps({
    modelValue: { type: Boolean, required: true },
    labelTrue: { type: String, default: 'Sim' },
    labelFalse: { type: String, default: 'Não' },
    labelCaption: { type: String, default: '' },
    btnWidth: { type: String, default: '100px' }
});
const emit = defineEmits(['update:modelValue']);

function updateValue(val) {
    emit('update:modelValue', val);
}
</script>

<style scoped>
.toggle-wrapper {
    display: inline-flex;
    border: 1px solid #ccc;
    border-radius: 6px;
    overflow: hidden;
    font-size: 14px;
}

.btn-toggle {
    padding: 4px 12px;
    background-color: #f9f9f9;
    color: #333;
    border: none;
    cursor: pointer;
    font-weight: 500;
    transition: all 0.2s ease;
    /* max-width: 100px; */
}

.btn-toggle:hover {
    background-color: #eaeaea;
}

.btn-toggle.active {
    background-color: #38615d;
    color: white;
}

.left {
    border-right: 1px solid #ccc;
}

.right {
    border-left: 1px solid transparent;
}
</style>
